import Vue from 'vue'
import { Plugin, PluginContainer } from './plugins'
import types from './types'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

export class SmartPlugin extends Plugin{
    constructor(name, props){
        super(name, {...props, smart:{required:true}});
    }
}

export class SmartPluginContainer extends PluginContainer{
    constructor(name, props){
        super(name, props);
    }

    inject(props){
        super.inject(props);
        props.smart = this.$options.smart;
    }
}

export default class Smart extends SmartPluginContainer{
    constructor(){
        super('smart');
    }

    inject(props){
        props.smart = this;
    }

    install(vue){
        vue.prototype.$smart = this;
        vue.prototype.$bpManager = this.$plugins['breakpoint-manager'];
    }

    
    registerComponents(filter) {
        var filterFunc = null;
        if (filter) {
            if (Array.isArray(filter)) {
                filterFunc = (name) => filter.findIndex(f => f.includes(name));
            } else if (typeof filter === types.function) {
                filterFunc = filter;
            }
        }

        const requireComponent = require.context('@/smart/components', false, /Smart[A-Z]\w+\.(vue|js)$/)

        var files = requireComponent.keys();
        if (filterFunc)
            files = files.filter(filterFunc);

        files.forEach(fileName => {
            // Get component config
            const componentConfig = requireComponent(fileName)

            // Get PascalCase name of component
            const componentName = upperFirst(
                camelCase(
                    // Strip the leading `./` and extension from the filename
                    fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
                )
            )

            // Register component globally
            Vue.component(
                componentName,
                // Look for the component options on `.default`, which will
                // exist if the component was exported with `export default`,
                // otherwise fall back to module's root.
                componentConfig.default || componentConfig
            )
        })
    }
    componentAsync(name) {
        return () => import(
            /* webpackChunkName: "components/[request]" */
            `@/components/${name}`)
    }
    viewAsync(name) {
        return () => import(
            /* webpackChunkName: "views/[request]" */
            `@/views/${name}`)
    }
    assetAsync(name) {
        return () => import(
            /* webpackChunkName: "assets/[request]" */
            `@/assets/${name}`)
    }
    iconAsync(name) {
        return () => import(
            /* webpackChunkName: "icons" */
            /* webpackMode: "eager" */
            `@/icons/${name}`)
    }
}